module.exports = __webpack_public_path__ + "static/media/crown.5b33d8e4.png";